enum KeyMapping {
  imageUrl = "imageURL",
  name = "Name/Description",
  tags = "tags",
}

export default KeyMapping;
